<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="WishEnum.WISH_AFTER_STUDY" i18n>Après mes études </ng-container>
  <ng-container *ngSwitchCase="WishEnum.WISH_BEFORE_THIRTY" i18n>Avant mes 30 ans</ng-container>
  <ng-container *ngSwitchCase="WishEnum.WISH_SOME_DAY" i18n>Un jour</ng-container>
  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
